import { useMemo } from "react"

/**
 * Hook to get archived status for projects
 * Returns a map of project slug to archived status
 *
 * Note: This uses a hardcoded list since the projects list API doesn't include archived_at field
 * TODO: Update this when we have a dedicated archived projects endpoint
 */
export function useProjectsArchiveStatus() {
  // Hardcoded list of known archived projects
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const archivedProjects = [
    "terra",
    // Need to update the project query to include archived_at field
  ]

  const archiveStatusMap = useMemo(() => {
    const map = new Map<
      string,
      { isArchived: boolean; archivedAt?: string; archivedReason?: string }
    >()

    // Mark all archived projects
    archivedProjects.forEach((slug) => {
      map.set(slug, {
        isArchived: true,
        archivedAt: undefined, // We don't have the actual date from the list API
        archivedReason: "Project archived",
      })
    })

    return map
  }, [archivedProjects])

  return {
    data: archiveStatusMap,
    isLoading: false,
    error: null,
  }
}
